module.exports = __webpack_public_path__ + "media/brands/rolls royce-a25718db.png";